// Конфигурация Google Sheets API
export const GOOGLE_SHEETS_CONFIG = {
  API_KEY: 'AIzaSyCZaf2kIBI9Xb1DCZtwIgr_28Z2Ld4dHvs',
  SPREADSHEET_ID: '1stAYfYFKxYv0s23jKCXZDfMYcxnsCSYefubI_ZrvNac',
  RANGE: 'АК.УК.ДК.ПК!C15:E25'
}

// URL для получения данных
export const getGoogleSheetsUrl = () => {
  return `https://sheets.googleapis.com/v4/spreadsheets/${GOOGLE_SHEETS_CONFIG.SPREADSHEET_ID}/values/${GOOGLE_SHEETS_CONFIG.RANGE}?key=${GOOGLE_SHEETS_CONFIG.API_KEY}`
}
